import { mergeDeep } from '~/helpers/objects'

export const strict = false

export const mutations = {
  RESTORE_STATE (state, stateToRestore) {
    state = mergeDeep(state, stateToRestore)
  }
}

export const actions = {
  RESET ({ commit, rootState }) {
    Object.keys(rootState).forEach((module) => {
      if (module === 'route') return
      commit(`${module}/RESET`)
    })
  }
}